'use client'
import React from 'react'
import { useParams } from 'next/navigation'

export default function NotFound () {
  // geth the reuest id of the url here
  const { assetId } = useParams()

  return (
    <>
      <main className='flex flex-col items-center justify-center min-h-screen p-4 text-center'>
        <div className='items-center justify-center mb-4 space-y-4 lg:gap-6 lg:flex lg:space-y-0'>
          <h2 className='text-xl font-bold xl:text-2xl '>Error 404 - Video unavailable</h2>
          <p className='text-lg xl:text-xl'>(Request ID: {assetId})</p>
        </div>
      </main>
    </>
  )
}
